module.exports = __webpack_public_path__ + "img/real_time_order.75e24c38.png";